import { GFAExperience } from "@dune/types";
import { Button, ControlledInput } from "@dune/ui";
import { Plus, Trash2 } from "lucide-react";
import { useFormContext } from "react-hook-form";
import { ControlledPriceInput } from "../../components/inputs/ControlledPriceInput";

interface GFAExperiencesContainerProps {
	isForm?: boolean;
}

const GFAExperiencesContainer = ({
	isForm = true,
}: GFAExperiencesContainerProps) => {
	const { control, setValue } = useFormContext();
	const { watch } = useFormContext();
	const experiences = watch("experiences");
	return (
		<div className="flex flex-col gap-4">
			<div className="flex flex-row gap-4">
				{isForm && (
					<h1 className="text-[#144C65] text-lg font-medium">
						OPÉRATIONS EN COURS OU LIVRÉES DANS LES 36 DERNIERS MOIS
					</h1>
				)}
			</div>
			<div className="border rounded-lg p-4 flex flex-col gap-4">
				<div className="flex flex-col gap-4">
					<div className="flex flex-row gap-4 w-[95%]">
						<div className="w-2/12">Opération</div>
						<div className="w-1/12">Année</div>
						<div className="w-2/12">Prix de vente TTC</div>
						<div className="w-2/12">Stade d'avancement en %</div>
						<div className="w-2/12">Stock invendu en €</div>
						<div className="w-3/12">
							Marge (prévisionnelle ou définitive en €)
						</div>
					</div>
					{experiences?.map((experience: GFAExperience, index: number) => (
						<div
							key={experience.id}
							className="flex flex-row gap-4 items-center"
						>
							<div className="flex flex-row gap-4 w-[95%]">
								<div className="w-2/12">
									<ControlledInput
										name={`experiences.${index}.operationName`}
										control={control}
										readOnly={!isForm}
									/>
								</div>

								<div className="w-1/12">
									<ControlledInput
										name={`experiences.${index}.year`}
										control={control}
										type="number"
										readOnly={!isForm}
									/>
								</div>

								<div className="w-2/12">
									<ControlledPriceInput
										name={`experiences.${index}.salePriceTTC`}
										control={control}
										iconOrText="€"
										readOnly={!isForm}
									/>
								</div>

								<div className="w-2/12">
									<ControlledInput
										name={`experiences.${index}.progressPercentage`}
										control={control}
										type="number"
										iconOrText="%"
										iconOrTextPosition="right"
										readOnly={!isForm}
									/>
								</div>

								<div className="w-2/12">
									<ControlledPriceInput
										name={`experiences.${index}.unsoldStockValue`}
										control={control}
										iconOrText="€"
										readOnly={!isForm}
									/>
								</div>

								<div className="w-3/12">
									<ControlledPriceInput
										name={`experiences.${index}.marginAmount`}
										control={control}
										iconOrText="€"
										readOnly={!isForm}
									/>
								</div>
							</div>

							{isForm && (
								<Trash2
									onClick={() => {
										setValue("experiences", [
											...experiences.slice(0, index),
											...experiences.slice(index + 1),
										]);
									}}
								/>
							)}
						</div>
					))}
					{isForm && (
						<Button
							onClick={() => {
								setValue("experiences", [
									...experiences,
									{ id: experiences.length + 1 },
								]);
							}}
							variant="none"
							size="none"
							className="self-start"
							type="button"
						>
							<div className="flex flex-row items-center gap-2 font-medium text-sm text-primary">
								<Plus /> Ajouter
							</div>
						</Button>
					)}
				</div>
			</div>
		</div>
	);
};

export default GFAExperiencesContainer;
